import React, { useEffect, useState } from 'react';
import MissingKenmerkenCta from './components/MissingKenmerkenCta';
import MissingKenmerkenWizard from './components/MissingKenmerkenWizard';
import TEST_ID from './index.testid';

export type Props = {
  dataTestId?: string;
  missingKenmerkIds: Array<number>;
  onActiveKenmerkIdChange: (kenmerkId: number | null) => void;
};

const MissingKenmerkenGuide: React.FCC<Props> = ({
  dataTestId = TEST_ID.CONTAINER,
  missingKenmerkIds,
  onActiveKenmerkIdChange,
}) => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [wizardKey, setWizardKey] = useState(0);

  useEffect(() => {
    if (missingKenmerkIds.length === 0) {
      setIsWizardOpen(false);
    }
  }, [missingKenmerkIds.length]);

  return (
    <div data-testid={dataTestId}>
      <MissingKenmerkenCta
        missingKenmerkIds={missingKenmerkIds}
        onOpenWizard={() => {
          setWizardKey(key => key + 1);
          setIsWizardOpen(true);
        }}
      />
      {isWizardOpen && (
        <MissingKenmerkenWizard
          key={wizardKey}
          missingKenmerkIds={missingKenmerkIds}
          onActiveKenmerkIdChange={onActiveKenmerkIdChange}
          onClose={() => setIsWizardOpen(false)}
        />
      )}
    </div>
  );
};

export default MissingKenmerkenGuide;
